import React, { useEffect, useState } from "react"
import { getStockRightFSData } from "../../../modules/quote/web"
import "./index.less"
import { quote_fs_trade_info, quote_item_fs_trade_info, quote_item_trade_info, quote_trade_info } from "../../shared/quotedata/index"
import { store } from "./store"
import { Observer } from "mobx-react-lite"
import { quotedata } from "../../shared/quotedata"
import { LoadStatus } from "../../shared/load_status"

export function UKTimeTrade(props: { quotedata: quotedata }) {
  return (
    <div className="content-hq">
      <SellAndBuy />
      <FSTrade quotedata={props.quotedata} />
    </div>
  )
}

function SellAndBuy() {
  return (
    <Observer>
      {() => (
        <>
          <ul className="tb-sell">
            <li>
              <span>卖1</span>
              {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).element}
              {quote_trade_info[quote_item_trade_info.卖1量](store.StockDetail).element}
            </li>
          </ul>
          <ul className="tb-buy">
            <li>
              <span>买1</span>
              {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).element}
              {quote_trade_info[quote_item_trade_info.买1量](store.StockDetail).element}
            </li>
          </ul>
        </>
      )}
    </Observer>
  )
}

function FSTrade(props: { quotedata: quotedata }) {
  const [tradeData, setTradeData] = useState<Array<string>>([])
  const [lastItem, setLastItem] = useState<string>("")

  useEffect(() => {
    ;(async () => {
      let result = await getStockRightFSData(props.quotedata.quotecode,16)
      setLastItem(result[result.length - 1])
      setTradeData(result.slice(0, 16))
    })()
  }, [])

  return (
    <ul className="tb-fenshi">
      <li>
        <span>时</span>
        <span>价</span>
        <span>量</span>
      </li>
      <>
        {tradeData.length > 0 &&
          tradeData.map((item: any, index: number) => {
            return (
              <li key={index}>
                {quote_fs_trade_info[quote_item_fs_trade_info.时间](item).element}
                {quote_fs_trade_info[quote_item_fs_trade_info.成交价](tradeData, lastItem, item, index, store.StockDetail, 15).element}
                {quote_fs_trade_info[quote_item_fs_trade_info.成交量](item).uk_element}
              </li>
            )
          })}
          {
            tradeData.length == 0 && <LoadStatus icon={false} title="暂无数据" className="time-trade-tips"/>
          }
      </>
    </ul>
  )
}
